import { getFetch } from './utilidades/getFetch';
import { tooglePassword } from './utilidades/tooglePassword';
import { ativarDialog } from './utilidades/ativarDialog';
import { loadFullPage } from './utilidades/loadFullPage';
import { postFetch } from './utilidades/postFetch';
import { isNullOrEmpty } from './utilidades/isNullOrEmpty';
import { Report } from 'notiflix/build/notiflix-report-aio';
import { obterQueryString } from "./utilidades/obterQueryString";
import { inicializarInternacionalizacao } from './localizacao/painel-cadastrar/painel-cadastrar';
import { addTrack } from './utilidades/trackEventos';
import { getGeoData } from './utilidades/geoData';
import { obterCandidaturaPendente, removerCandidaturaPendente } from './utilidades/candidaturaPendente';
import { removeCacheUsuarioLogado } from './utilidades/usuarioLogado';

import IMask from 'imask';
import JustValidate from 'just-validate';
import i18next from 'i18next';


const cadastroInicial = function () {

    const $form = document.getElementById('form-cadastro-candidato');
    const decisaoIDExterno = document.getElementById('codigo-externo-switch');
    const somenteMostrarCodigoExterno = $form.getAttribute('data-exibir-codigo') == 'True' ? true : false;
    let geoData;   
    let tipoCadastroAtual = somenteMostrarCodigoExterno ? 'colaborador' : 'candidato';

    let cadastroPendente = false;

    const _verificacoes = {
        CadastroAutorizado: function () {
            loadFullPage.esconder();
        },
        CpfInvalido: function () {
            loadFullPage.esconder();
            $form.querySelector('#cpf').focus();
            Report.failure(i18next.t('ValidacaoFormularioCpfInvalido'), '', i18next.t('ReportCpfInvalidoCorrigir'), null);
        },
        IdExternoInvalido: function () {
            loadFullPage.esconder();
            $form.querySelector('#id-externo').focus();
            const nomeIdExterno = document.getElementById('nome-id-externo').textContent;
            Report.failure(i18next.t('ValidacaoFormularioIdExternoInvalido').replace('{0}', nomeIdExterno), '', i18next.t('ReportIdExternoInvalido'), null);
        },
        CompletarCadastroImportado: function () {
            loadFullPage.esconder();
            return true;
        },
        IncluirNoArquivoDaEmpresa: function () {
            ativarDialog(i18next.t('ReportJaPossuiCadastro'), i18next.t('ArquivoEmpresaUtilizaSistema'), i18next.t('AcessarCadastroExistente'), i18next.t('ArquivoEmpresaReportSair'),
                () => {
                    loadFullPage.mostrar();
                    let returnUrl = obterQueryString()['redirect'];
                    if (isNullOrEmpty(returnUrl)) {
                        returnUrl = '';
                    }
                    location.href = '/' + CULTURE_EMPREGARE + '/login?tipo=candidato&ReturnUrl=' + returnUrl;
                },
                () => {
                    loadFullPage.mostrar();
                    location.href = '/' + CULTURE_EMPREGARE;
                });
            return;
        },
        UsuarioJaCadastrado: function () {
            loadFullPage.esconder();
            Report.info(i18next.t('ReportJaPossuiCadastro'), i18next.t('ReportUsuarioJaCadastrado'), i18next.t('AcessarCadastroExistente'),
                () => {
                    loadFullPage.mostrar();

                    let returnUrl = obterQueryString()['redirect'];
                    if (isNullOrEmpty(returnUrl)) {
                        returnUrl = '';
                    }

                    let cpfDigitado = '';
                    if (document.getElementById('paisID').value == 'BR') {
                        cpfDigitado = document.getElementById('cpf').value;
                    }

                    location.href = `/${CULTURE_EMPREGARE}/login?cpf=${cpfDigitado}&ReturnUrl=${returnUrl}`;
                });
            return;
        },
        CadastroBloqueado: function () {
            loadFullPage.esconder();
            Report.warning(i18next.t('ReportCadastroDesativado'), i18next.t('ReportCadastroDesativadoTexto', { interpolation: { escapeValue: false } }), i18next.t('AcessarCadastroExistente'),
                () => {
                    loadFullPage.mostrar();

                    let returnUrl = obterQueryString()['redirect'];
                    if (isNullOrEmpty(returnUrl)) {
                        returnUrl = '';
                    }
                    location.href = '/' + CULTURE_EMPREGARE + '/login?tipo=candidato&ReturnUrl=' + returnUrl;
                });
            return;
        }
    }
    const _verificarCpf = async function (cpf) {

        let lenCpf = cpf.length;
        if (lenCpf === 0) {
            return;
        }
        if (lenCpf < 14) {
            _verificacoes.CpfInvalido();
            return;
        }

        loadFullPage.mostrar(i18next.t('VerificandoCpf'));

        const callbackSucesso = (resultado) => {
            _verificacoes[resultado.metodo]();
        }
        const callbackErro = (resultado) => {
            loadFullPage.esconder();
        }

        let urlFetch = `/${CULTURE_EMPREGARE}/PainelCadastrar/VerificarCpf?cpf=${cpf}`;

        if (cadastroPendente) {
            urlFetch += `&cadastroPendente=${cadastroPendente}`;
        }

        await getFetch(urlFetch, callbackSucesso, callbackErro, callbackErro);
    };

    const _salvar = async function () {


        let timeZone = '';

        try {
            if (geoData.existe) {
                timeZone = geoData.data.timezone;
            } else {
                timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            }
        } catch (e) { }

        loadFullPage.mostrar();

        let formData = new FormData($form);
        formData.append('timeZone', timeZone);      

        const callbackSucesso = (resultado) => {
            addTrack('Iniciou Cadastro');
            window.location.href = resultado.url;
        }
        const callbackErro = (resultado) => {
            loadFullPage.esconder();
            if (isNullOrEmpty(resultado.mensagem)) {
                _verificacoes[resultado.metodo]();
            }

        }

        await postFetch(
            cadastroPendente ? `/${CULTURE_EMPREGARE}/PainelCadastrar/CadastroPendente` : `/${CULTURE_EMPREGARE}/PainelCadastrar/Index`,
            formData,
            callbackSucesso,
            callbackErro,
            callbackErro
        );

    };

    const _pessoaImportado = function () {

        const tokenPessoa = document.getElementById('TokenPessoa').value;

        const _excluirCadastro = async function () {
            loadFullPage.mostrar();

            const callbackSucesso = (resultado) => {
                loadFullPage.esconder();
                Report.success(i18next.t('CadastroImportadoCadastroExcluido'), '', i18next.t('Ok'),
                    () => {
                        loadFullPage.mostrar();
                        window.location.href = resultado.url;
                    });
            }
            const callbackErro = (resultado) => {
                loadFullPage.esconder();
            }


            let formData = new FormData();
            formData.append('token', tokenPessoa);

            await postFetch(`/${CULTURE_EMPREGARE}/PainelCadastrar/ExcluirCadastroPendente`, formData, callbackSucesso, callbackErro, callbackErro);
        };
        const _carregarDadosPessoa = async function () {

            loadFullPage.mostrar();

            const callbackSucesso = (resultado) => {
                let pessoa = resultado.data;
                
                const dataNascimento = isNullOrEmpty(pessoa.DataNascimento) ? null : new Date(parseInt(pessoa.DataNascimento.replace("/Date(", "").replace(")/", "")));

                if (cadastroPendente) {
                    if (dataNascimento != null &&
                        dataNascimento.getUTCDay() != 0 && document.getElementById('nascimento-dia').value.trim().length > 0 &&
                        (dataNascimento.getUTCMonth() + 1) != 0 && document.getElementById('nascimento-mes').value.trim().length > 0 &&
                        dataNascimento.getUTCFullYear() != 0 && document.getElementById('nascimento-ano').value.trim().length > 0) {
                        $form.querySelector("#row-nascimento").classList.add('d-none');
                    }

                    if (!isNullOrEmpty(pessoa.Email)) {
                        $form.querySelector("#row-email").classList.add('d-none');
                    }

                    //Caso seja CidadeID=BR, terá opção de selecionar país, estado e cidade
                    //if (!isNullOrEmpty(pessoa.PaisID)) {
                    //    $form.querySelector("#row-pais").classList.add('d-none');
                    //}

                   
                }

                $form.querySelector("#nome").value = pessoa.Nome;
                $form.querySelector("#email").value = pessoa.Email;
                $form.querySelector("#email-confirmar").value = pessoa.Email;
                //$form.querySelector("#paisID").value = pessoa.PaisID;
               
                $form.querySelector("button[type='submit']").innerHTML = i18next.t('CadastroImportadoConfirmarCadastro');
                loadFullPage.esconder();
            }
            const callbackErro = (resultado) => {
                loadFullPage.esconder();
            }
            await getFetch(`/${CULTURE_EMPREGARE}/PainelCadastrar/ObterDadosCandidatoPendente?token=${tokenPessoa}`, callbackSucesso, callbackErro, callbackErro);
        };

        const _init = function () {

            document.getElementById('btn-recusar').addEventListener('click', function (e) {

                ativarDialog(i18next.t('CadastroImportadoRecusarExcluir'), i18next.t('CadastroImportadoConfirmarExclusao'), i18next.t('CadastroImportadoSimExcluir'), i18next.t('CadastroImportadoNao'),
                    () => {
                        _excluirCadastro();
                    },
                    () => { });

            });

            _carregarDadosPessoa();
        };

        return _init();
    };

    const _trocarTipoCadastro = function (outroTipoBotao, formJustValidate) {

        const paisID = document.getElementById('paisID');
        const idExterno = document.getElementById('row-id-externo');

        if (tipoCadastroAtual == 'candidato') {
            tipoCadastroAtual = 'colaborador';
            paisID.dispatchEvent(new Event('change'));
            idExterno.classList.remove('d-none');
            outroTipoBotao.textContent = document.getElementById('botao-tipo-cadastro-candidato').textContent;

            const nomeIdExterno = document.getElementById('nome-id-externo').textContent;
            const regex = document.getElementById('regex-validacao').textContent;
            formJustValidate.addField('#id-externo', [{ rule: 'required', errorMessage: i18next.t('_trocarTipoCadastroInformarCodigoExterno').replace('{0}', nomeIdExterno) }, { rule: 'customRegexp', value: regex }])

            return;
        }

        tipoCadastroAtual = 'candidato'

        paisID.dispatchEvent(new Event('change'));
        idExterno.classList.add('d-none');
        idExterno.querySelector('input').value = '';

        outroTipoBotao.textContent = document.getElementById('botao-tipo-cadastro-colaborador').textContent;
        formJustValidate.removeField('#id-externo');
    };

    const _init = function () {
        inicializarInternacionalizacao();

        geoData = getGeoData();
        removeCacheUsuarioLogado();

        const candidaturaPendente = obterCandidaturaPendente();
        if (candidaturaPendente.vagaID != '0') {
            const containerCandidatura = document.getElementById('container-candidatura-pendente');

            containerCandidatura.classList.remove('d-none');
            containerCandidatura.querySelectorAll('.candidatura-pendente-titulo').forEach(div => {
                div.innerHTML = candidaturaPendente.titulo
            });

            containerCandidatura.querySelector('#vagaIDCandidaturaPendente').value = candidaturaPendente.vagaID;

            containerCandidatura.querySelector('.btn-close').addEventListener('click', async function (e) {
                await removerCandidaturaPendente(false);
                const $containerRemovido = document.getElementById('container-candidatura-pendente');
                $containerRemovido.classList.add('d-none');
                $containerRemovido.querySelector('#vagaIDCandidaturaPendente').value = '0';
            });

        }

        let paisID = 'BR';        

        if (geoData.existe) {
            paisID = geoData.data.pais;            
        }

        cadastroPendente = location.pathname.includes('cadastro-pendente');
        //#region validacoes
        const formValidar = new JustValidate($form, {
            errorFieldCssClass: 'is-invalid',
            focusInvalidField: true,
            lockForm: true
        });

        const selecione = [{ rule: 'required', errorMessage: i18next.t('ValidacaoFormularioSelecioneGenerico') }]

        formValidar.addField('#nome', [{ rule: 'required', errorMessage: i18next.t('ValidacaoFormularioInformeNome') }])
            .addField('#nascimento-dia', selecione)
            .addField('#nascimento-mes', selecione)
            .addField('#nascimento-ano', selecione)           
            .addField('#email', [{ rule: 'required', errorMessage: i18next.t('ValidacaoFormularioInformeEmail') }, { rule: 'email', errorMessage: i18next.t('ValidacaoFormularioInformeEmail') }])
            .addField('#paisID', [{
                rule: 'required',
                errorMessage: i18next.t('ValidacaoFormularioSelecionePais'),
            }
            ])
            .addField('#cpf', [{
                rule: 'required',
                errorMessage: i18next.t('ValidacaoFormularioInformeCpf')
            }
            ])
            .addField('#senha', [{
                rule: 'required',
                errorMessage: i18next.t('ValidacaoFormularioInformeSenha'),
            }, {
                rule: "minLength",
                value: 4,
                errorMessage: i18next.t('ValidacaoFormularioSenhaMinCaracteres'),
            },
            {
                rule: "maxLength",
                value: 25,
                errorMessage: i18next.t('ValidacaoFormularioSenhaMaxCaracteres'),
            }
            ])
            .addField('#email-confirmar',
                [
                    {
                        validator: (value, fields) => {
                            let valido = false;

                            for (const fieldKey of Object.keys(fields)) {
                                if (fields[fieldKey].elem.getAttribute('id') !== 'email') {
                                    continue;
                                }

                                if (fields[fieldKey].elem.value === '' || fields[fieldKey].elem.value !== value) {
                                    valido = false;
                                } else {
                                    valido = true;
                                }
                            }

                            return valido;
                        },
                        errorMessage: i18next.t('ValidacaoFormularioConfirmarEmail')
                    },
                ])
            .addField('#termosUso', [{
                rule: 'required',
                errorMessage: i18next.t('ValidacaoFormularioAceitarTermos')
            }]);
        //#endregion

        document.getElementById('paisID').addEventListener('change', function (e) {
            const $elementoCpf = $form.querySelector('#row-cpf');
            if (e.target.value === 'BR' && tipoCadastroAtual == 'candidato') {
                $elementoCpf.classList.remove('d-none');
                formValidar.addField('#cpf', [{ rule: 'required', errorMessage: i18next.t('ValidacaoFormularioInformeCpf') }]);
            } else {
                formValidar.removeField('#cpf');
                $elementoCpf.classList.add('d-none');
            }           
        });
       
        const inputCpf = $form.querySelector('#cpf');
        IMask(inputCpf, {
            mask: "000.000.000-00"
        });

        inputCpf.addEventListener('blur', (e) => {
            _verificarCpf(e.target.value);
        });

        tooglePassword($form.querySelector("#senha"), $form.querySelector("#togglePassword"));



        if (!isNullOrEmpty(paisID)) {
            document.getElementById('paisID').value = paisID;
            document.getElementById('paisID').dispatchEvent(new Event('change', { bubbles: false, cancelable: true }));
        }        

        $form.addEventListener('submit', (e) => {
            formValidar.revalidate().then((isValid) => {
                if (!isValid) {
                    return;
                }
                _salvar();
            });

            e.preventDefault();
        });


        const $pessoaImportado = document.getElementById('pessoa-importado-pendente');
        if (document.contains($pessoaImportado)) {
            _pessoaImportado();
        } 

        if (document.querySelector('.btn-login')) {
            const btnLogin = document.querySelector('.btn-login').classList;
            btnLogin.add('btn-primary');
            btnLogin.remove('btn-outline-primary');
        }
        addTrack('Abriu Tela Cadastro');


        const idExterno = document.getElementById('row-id-externo');
        if (idExterno) {
            if (tipoCadastroAtual == 'candidato') {
                idExterno.classList.add('d-none');
            } else {
                const nomeIdExterno = document.getElementById('nome-id-externo').textContent;
                const regex = document.getElementById('regex-validacao').textContent;
                formValidar.addField('#id-externo', [{ rule: 'required', errorMessage: i18next.t('_trocarTipoCadastroInformarCodigoExterno').replace('{0}', nomeIdExterno) }, { rule: 'customRegexp', value: regex, errorMessage: `${nomeIdExterno} inválido` }])
            }

            if (somenteMostrarCodigoExterno)
                return;

            const outroTipo = document.getElementById('outro-tipo-cadastro');
            const isColaborador = tipoCadastroAtual == 'colaborador';
            outroTipo.textContent = isColaborador ? i18next.t('_trodarTipoCadastroIDExternoNao') : i18next.t('_trocartipoCadastroIDExternoSim');


            outroTipo.addEventListener('click', () => _trocarTipoCadastro(outroTipo, formValidar))
        }

        let queryStringNome = obterQueryString()['nome'];
        let queryStringEmail = obterQueryString()['email'];

        const inputNome = document.getElementById('nome');
        const inputEmail = document.getElementById('email');
        const inputConfirmarEmail = document.getElementById('email-confirmar');

        if (queryStringNome && inputNome) {
            inputNome.value = queryStringNome;
        }

        if (queryStringEmail && inputEmail && inputConfirmarEmail) {
            inputEmail.value = inputConfirmarEmail.value = queryStringEmail;
        }
    };

    if (decisaoIDExterno) {
        const tiposDeCadastro = document.getElementsByClassName('tipo-cadastro');
        for (const tipo of tiposDeCadastro) {
            tipo.addEventListener('click', () => {
                decisaoIDExterno.classList.add('d-none')
                $form.classList.remove('d-none')

                const tipoCadastro = tipo.getAttribute('data-tipo-cadastro');
                tipoCadastroAtual = tipoCadastro;
                _init();
            })
        }

        return;
    }
    _init();
};

cadastroInicial();